import styled from "@emotion/styled";
import theme from "../../styles/theme";

interface ICarouselProps {
  activeIndex: number;
}

interface ICarouselDotProps {
  isActive: boolean;
}

export const ImageCarouselBase = styled.div`
  text-align: center;
  padding: 0 ${theme.spacing[4]};
  margin: ${theme.spacing[8]} auto;

  ${theme.largerThan["2xl"]} {
    padding: 0;
  }
`;

export const CarouselInline = styled.div`
  position: relative;
`;

export const Caption = styled.div`
  margin-top: 8px;
  font-size: 13px;
  line-height: 20px;
  color: ${theme.colors.darkBlues[75]};
`;

export const CarouselScroller = styled.div`
  position: relative;
  overflow: hidden;
`;

export const CarouselItems = styled.div<ICarouselProps>`
  display: grid;
  grid-auto-columns: 100%;
  grid-auto-flow: column;
  transition: all 500ms ease-in-out;
  ${(props) => `transform: translateX(-${props.activeIndex * 100}%);`};
`;

export const CarouselItem = styled.div`
  .gatsby-image-wrapper {
    border-radius: ${theme.borderRadius};
  }
`;

export const CarouselDots = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  width: 100%;
  justify-content: center;
  position: absolute;
  bottom: 1rem;
  left: 0;
  right: 0;
`;

export const CarouselDot = styled.li<ICarouselDotProps>`
  padding: 0.5rem 0.25rem;
  cursor: pointer;

  &:before {
    content: "";
    display: block;
    width: 0.5rem;
    height: 0.5rem;
    border-radius: 0.5rem;
    ${(props) =>
      props.isActive
        ? `
        background-color: ${theme.colors.blues[100]};
        border: 1px solid ${theme.colors.blues[25]};
      `
        : `
        background-color: ${theme.colors.white};
        border: 1px solid ${theme.colors.blues[25]};
        opacity: 0.5;
      `}
    transition: all 250ms ease-in-out;
  }

  &:hover {
    &:before {
      background-color: ${theme.colors.blues[100]};
      border: 1px solid ${theme.colors.blues[100]};
      opacity: 1;
    }
  }
`;

export const CarouselImage = styled.img`
  max-width: 100%;
  height: auto;
`;
